module.exports = __webpack_public_path__ + "b0bdb3f0dfb5b72b1ea390d4f7f281b2.png";